import { render } from "./my-referrals.vue?vue&type=template&id=546aef86"
import script from "./my-referrals.vue?vue&type=script&lang=js"
export * from "./my-referrals.vue?vue&type=script&lang=js"

import "./my-referrals.vue?vue&type=style&index=0&id=546aef86&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__